import { c as _c } from "react/compiler-runtime";
// import Component from './component';
import React from 'react';
import { ViewErrorBoundary } from 'shared/error-boundry';
import { BareLayout } from '../../layout';
import { BorderBox } from '../shared';
const Component = React.lazy(() => import('./component'));

// import Component from './component';

// const isServer = typeof window === 'undefined';

// const NoServer = () => {
//   console.log('bbbb');
//   if (isServer) {
//     console.log('HEREeeeeeeeeeeeeeeeeee');
//     throw new Promise((resolve) => {
//       setTimeout(() => {
//         resolve(0);
//       }, 1000);
//     });
//   }
//   return null;
// };

const ViewWrapper = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [0, 6];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <BareLayout><ViewErrorBoundary><BorderBox pt={t0} maxWidth="700px" mx="auto"><Component {...props} /></BorderBox></ViewErrorBoundary></BareLayout>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ViewWrapper;